// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntextarea[data-v-2f10ac74] {\n  padding: 0.538rem;\n  border: 1px solid var(--light-border);\n}\n", ""]);
// Exports
module.exports = exports;
